import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TTableHeader, IDeps } from './models';
import { TableHeader as Component } from './table-header';
import styles from './styles/styles.css';

export const TableHeader = createWidget<IDeps, TTableHeader>({ styles })(Component);
